import React from 'react';

import InputConfig from '../../../../../Components/InputConfig';
import SwitchInput from '../../../../../Components/SwitchInput';
import ArrayInputConfigv2 from '../../../../../Components/ArrayInputConfigv2';
import { Grid } from '@mui/material';
import { identifyVastTagPartner } from '../../../../../utilities/vastTagPartner';
import useVastTagPartnerMappings from '../../../../../CustomHooks/useVastTagPartnerMappings';

const getVastTagStatus = (vastTag, partnerMappings) => {
	if (!vastTag?.trim()) return null;
	const match = identifyVastTagPartner(vastTag, partnerMappings);
	return match
		? {
				label: match.partner,
				details: 'Mapped Successfully',
				type: 'success'
			}
		: {
				label: 'Partner not identified',
				details: 'Please enter a valid Vast Tag',
				type: 'error'
			};
};

const CountryWiseDaisyChainData = ({
	selectedDaisyChainingCountry,
	daisyChainingConfig,
	updateDaisyChainingConfig,
	keyData
}) => {
	const partnerMappings = useVastTagPartnerMappings();

	return (
		<>
			<Grid
				container
				spacing={1}
				style={{
					width: '100%',
					marginTop: '1rem',
					padding: '1rem'
				}}
			>
				<Grid item xs={3.3}>
					<InputConfig
						label="Dc Vast Limit"
						inputType="number"
						isObjectEditor={false}
						directValue={
							daisyChainingConfig && daisyChainingConfig[selectedDaisyChainingCountry]?.dcVastLimit
						}
						updateDirectValue={(newValue) =>
							updateDaisyChainingConfig(selectedDaisyChainingCountry, 'dcVastLimit', newValue)
						}
						keyData={`${keyData}.dcVastLimit`}
					/>
				</Grid>
				<Grid item xs={3.3}>
					<InputConfig
						label="Default Vast Limit"
						inputType="number"
						isObjectEditor={false}
						directValue={
							daisyChainingConfig &&
							daisyChainingConfig[selectedDaisyChainingCountry]?.defaultVastLimit
						}
						updateDirectValue={(newValue) =>
							updateDaisyChainingConfig(selectedDaisyChainingCountry, 'defaultVastLimit', newValue)
						}
						keyData={`${keyData}.defaultVastLimit`}
					/>
				</Grid>
				<Grid item xs={3.3}>
					<InputConfig
						label="Initial Requests"
						inputType="number"
						isObjectEditor={false}
						directValue={
							daisyChainingConfig &&
							daisyChainingConfig[selectedDaisyChainingCountry]?.initialRequestsLimit
						}
						updateDirectValue={(newValue) =>
							updateDaisyChainingConfig(
								selectedDaisyChainingCountry,
								'initialRequestsLimit',
								newValue
							)
						}
						keyData={`${keyData}.initialRequestsLimit`}
					/>
				</Grid>
				<Grid
					item
					xs={2}
					style={{
						display: 'flex',
						justifyContent: 'left',
						alignItems: 'center',
						marginTop: '1.5rem',
						paddingLeft: '2.5rem'
					}}
				>
					<SwitchInput
						label="Start with Dc"
						disabled={false}
						isObjectEditor={false}
						containerStyles={{ marginTop: '2rem' }}
						labelStyles={{ width: '100%' }}
						directValue={
							!!(
								daisyChainingConfig &&
								daisyChainingConfig[selectedDaisyChainingCountry]?.startWithDcVasts
							)
						}
						updateDirectValue={(newValue) =>
							updateDaisyChainingConfig(selectedDaisyChainingCountry, 'startWithDcVasts', newValue)
						}
						keyData={`${keyData}.startWithDcVasts`}
					/>
				</Grid>
			</Grid>

			<Grid
				container
				spacing={1}
				style={{
					width: '99%',
					margin: '1rem 0 2rem 0rem'
				}}
			>
				<Grid item xs={12}>
					<ArrayInputConfigv2
						label="VastTags"
						isObjectEditor={false}
						directValue={
							daisyChainingConfig && daisyChainingConfig[selectedDaisyChainingCountry]?.vastTags
						}
						updateDirectValue={(newValue) =>
							updateDaisyChainingConfig(selectedDaisyChainingCountry, 'vastTags', newValue)
						}
						inputGridStyle={{
							display: 'flex',
							width: '100% !important',
							maxWidth: 'unset !important',
							marginTop: '1rem'
						}}
						getItemStatus={(vastTag) =>
							partnerMappings === null ? null : getVastTagStatus(vastTag, partnerMappings)
						}
						keyData={`${keyData}.vastTags`}
					/>
				</Grid>
			</Grid>
		</>
	);
};

export default CountryWiseDaisyChainData;
